module.exports = __webpack_public_path__ + "static/media/dr-lokuketagoda-old.887a2efd.jpg";